import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// interfaces.
import { ExceptionRule, IncentiveStep } from "@pages/RulesPage/modules/RulesMain/rulesData";

interface RulesState {
  exceptions: ExceptionRule[];
  incentiveStepsCO: IncentiveStep[];
  incentiveStepsMX: IncentiveStep[];
  isSaving: boolean;
}

const initialState: RulesState = {
  exceptions: [],
  incentiveStepsCO: [],
  incentiveStepsMX: [],
  isSaving: false,
};

export const rulesSlice = createSlice({
  initialState,
  name: "rules",
  reducers: {
    setIsSaving(state, action: PayloadAction<boolean>) {
      state.isSaving = action.payload;
    },
    setRulesForCountry(
      state,
      action: PayloadAction<{
        country: string;
        exceptions: ExceptionRule[];
        steps: IncentiveStep[];
      }>,
    ) {
      const { country, exceptions, steps } = action.payload;
      state.exceptions = exceptions;
      if (country === "MX") {
        state.incentiveStepsMX = steps;
      } else {
        state.incentiveStepsCO = steps;
      }
    },
    updateException(state, action: PayloadAction<ExceptionRule>) {
      state.exceptions = state.exceptions.map((exc) =>
        exc.id === action.payload.id ? action.payload : exc,
      );
    },
    updateIncentiveStep(
      state,
      action: PayloadAction<{ country: string; step: IncentiveStep }>,
    ) {
      const { country, step } = action.payload;
      if (country === "MX") {
        state.incentiveStepsMX = state.incentiveStepsMX.map((s) =>
          s.id === step.id ? step : s,
        );
      } else {
        state.incentiveStepsCO = state.incentiveStepsCO.map((s) =>
          s.id === step.id ? step : s,
        );
      }
    },
  },
});

export const {
  setIsSaving,
  setRulesForCountry,
  updateException,
  updateIncentiveStep,
} = rulesSlice.actions;

export default rulesSlice.reducer;
